import { CompanyOCRSettings, TransportFeeSettings } from '../types';

export const DEFAULT_OCR_SETTINGS: Partial<CompanyOCRSettings> = {
  ocrEnabled: true,
  autoAddressExtraction: true,
  autoPhoneExtraction: true,
  confidenceThreshold: 0.8,
  maxFilesPerUpload: 5,
  maxFileSizeMB: 10,
};

export const DEFAULT_TRANSPORT_FEE_SETTINGS: TransportFeeSettings = {
  calculation_method: 'fixed',
  fixed_fee: 15000,
};
